import { useEffect, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';

import { BioType } from "contexts/bio_context";
import useBio from "hooks/useBio";
import useUserIdentity from "hooks/useUserIdentity";
import UpdateableField from "components/UpdateableField";

import { getIcon } from 'utils/misc';

const IdentityBio = observer(({ identityKey }: { identityKey: string }) => {

    const { fetchBio } = useBio();
    const [bio, setLocalBio] = useState<BioType | null>();
    const [fetched, setFetched] = useState(false);
    const { currentIdentity } = useUserIdentity();

    const ReplayIcon = getIcon("Replay");

    useEffect(() => {
        setFetched(false);
    }, [identityKey]);

    const localFetchBio = useCallback(() => {
        if (!fetched) {
            setFetched(true);
            fetchBio(identityKey).then((data) => {
                setLocalBio(data);
            });
        }
    }, [identityKey, fetchBio, fetched]);

    useEffect(() => {
        localFetchBio();
    }, [localFetchBio, identityKey]);

    if (!bio)
        return <Typography endDecorator={<ReplayIcon />}>Checking</Typography>;

    if (!bio.one_liner && !bio.about && !(currentIdentity.key === identityKey))
        return <Typography level="body-xs" >This person has not added a bio.</Typography>;

    console.log("rendering with oneliner:", bio.one_liner);
    return (
        <Stack>

            <UpdateableField
                editable={currentIdentity.key === identityKey}
                value={bio.one_liner}
                type="bio"
                field="one_liner"
                level="title-md"
                placeholder="One Liner" />

            <UpdateableField
                editable={currentIdentity.key === identityKey}
                value={bio.about}
                multiline={true}
                type="bio"
                field="about"
                placeholder="About me: I like to..." />
            <Typography level="body-xs">Bios are visibile to {' '}
                { currentIdentity.role === 'assistant' ? 'clients and assistants' : 'assistants' }.
                </Typography>
        </Stack>
    );
});

export default IdentityBio;
